import Vue from 'vue';
import Router from 'vue-router';
import AppMain from '@/AppMain';
import AppComplete from '@/AppComplete';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'appMain',
      component: AppMain,
    },
    {
      path: '/complete',
      name: 'appComplete',
      component: AppComplete,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js